import gql from 'graphql-tag'

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    getCurrentUser {
      id
      uuid
      name
      firstName
      lastName
      phoneNumber
      dateOfBirth
      gender
      email
      phoneNumber
      timezone
      locale
      skypeUsername
      twitterProfile
      facebookProfile
      linkedinProfile
      secondaryEmail
      referrerId
      referrerState
      tags {
        id
        name
      }
      salesChannel
      salesSource
      salesMedium
      salesCampaign
      salesReferrer
      location {
        address
        city
        country
      }
      avatar {
        cloudinaryId
        cloudinaryType
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetCurrentUserFull.tsx